import { AgGridModule } from '@ag-grid-community/angular';
import { NgModule } from '@angular/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { PageTitleModule } from 'app/layout/components/page-title/page-title.module';
import { AnalyticsAna1Component } from 'app/main/analytics/analytics-ana1/analytics-ana1.component';
import { AnalyticsAna2Component } from 'app/main/analytics/analytics-ana2/analytics-ana2.component';
import { AnalyticsAna3Component } from 'app/main/analytics/analytics-ana3/analytics-ana3.component';
import { AnalyticsGroupsComponent } from 'app/main/analytics/analytics-groups/analytics-groups.component';
import { AnalyticsComponent } from 'app/main/analytics/analytics.component';
import { MaterialModule } from 'app/main/material.module';
import {
  ColorCellComponent,
  ColorCellModule,
} from 'app/main/shared/color-cell';
import { KeyValueCellRendererComponent } from 'app/main/shared/key-value-cell-renderer/key-value-cell-renderer.component';
import { MomentModule } from 'ngx-moment';
import { CancelConfirmButtonsModule } from 'app/main/shared/cancel-confirm-buttons/cancel-confirm-buttons.module';

import { CheckboxCellComponent } from 'app/main/shared/checkbox-cell/checkbox-cell.component';
import { AnalyticsEffects } from './analytics.effects';
import { reducers } from 'app/main/analytics/reducers';
import { AnalyticsResolver } from 'app/main/analytics/analytics.resolver';
import { AnalyticsTreeComponent } from 'app/main/analytics/analytics-tree/analytics-tree.component';
import { AnalyticsReportComponent } from 'app/main/analytics/analytics-report/analytics-report.component';

@NgModule({
  declarations: [
    AnalyticsComponent,
    AnalyticsAna1Component,
    AnalyticsAna2Component,
    AnalyticsAna3Component,
    AnalyticsGroupsComponent,
    AnalyticsTreeComponent,
    AnalyticsReportComponent,
  ],
  imports: [
    FuseSharedModule,
    MaterialModule,
    ColorCellModule,
    CancelConfirmButtonsModule,

    // AG Grid
    AgGridModule.withComponents([
      KeyValueCellRendererComponent,
      CheckboxCellComponent,
      ColorCellComponent,
    ]),

    PageTitleModule,
    MomentModule,
    StoreModule.forFeature('analytics', reducers),
    EffectsModule.forFeature([AnalyticsEffects]),
  ],
  exports: [AnalyticsComponent],
  providers: [AnalyticsResolver],
})
export class AnalyticsModule {}
